import type { LegalPerson, NaturalPerson, Partner, Person } from 'partner-api'

export const isNaturalPerson = (person: Person | undefined): person is NaturalPerson => {
  return person?.type === 'NaturalPerson'
}

export const isLegalPerson = (person: Person | undefined): person is LegalPerson => {
  return person?.type === 'LegalPerson'
}

export const fullNameWithSalutation = (partner: Partner): string => {
  if (!partner) return ''
  const person = partner.person
  let fullName = ''
  if (isNaturalPerson(person)) {
    const naturalPersonName = person.name
    if (!naturalPersonName) return ''
    // start with salutation
    fullName += naturalPersonName.salutation?.value ?? ''

    // add academic title
    if (
      naturalPersonName.academicTitle !== undefined &&
      naturalPersonName.academicTitle !== ''
    ) {
      fullName += ' ' + naturalPersonName.academicTitle
    }

    // finally add firstname and lastname
    fullName += ` ${naturalPersonName.firstName} ${naturalPersonName.name}`
  }
  return fullName.trim()
}
